





















































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import CartModule from "@/store/modules/tienda_cart_module";
import { CartHistory } from "@/shared/dtos/CartHistory";
import { TiendaCartHistoryLocalService } from "@/shared/services/tienda_cart_history_local_service";
import { RouterNames } from "@/router/routernames";
import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import { ProcessoNums } from "../procesos/ProcessoNums";
import TiendaOnlineClientesModule from "@/store/modules/TiendaOnlineClientes-module";
import PublicarWpPopup from "@/components/wordpress/PublicarWpPopup.vue";

@Component({ components: { PublicarWpPopup } })
export default class CartHistoryView extends Vue {
  private history: any[] = [];
  private snackbar: boolean = false;
  private snackbarText: string = "";
  private snackbarColor: string = "success";
  private searchQuery: string = "";
  private searchCliente: string = "";
  private sortBy: string = "recent";
  private filtroEstado: string = "todos";
  private filtroVerificado: string = "todos";
  private filtroFecha: string = "todos";
  private expandedCart: any = null;
  private confirmDialog: boolean = false;
  private itemToDelete: any = null;
  private cartToDeleteType: 'cart' | 'item' | null = null;
  private isDeleting: boolean = false;
  private itemsVerificados: any[] = [];
  private dialogWordpress: boolean = false;
  private carritoSeleccionado: any = null;

  private sortOptions = [
    { text: "Más reciente", value: "recent" },
    { text: "Más antiguo", value: "oldest" },
    { text: "Mayor precio", value: "price-high" },
    { text: "Menor precio", value: "price-low" },
    { text: "Más artículos", value: "items-most" },
    { text: "Menos artículos", value: "items-least" },
  ];

  // Opciones para filtro de estado del carrito
  private estadoOptions = [
    { text: "Todos los estados", value: "todos" },
    { text: "En curso", value: "en_curso" },
    { text: "Finalizado", value: "finalized" },
  ];

  // Opciones para filtro de verificado
  private verificadoOptions = [
    { text: "Todos", value: "todos" },
    { text: "Verificado", value: "verificado" },
    { text: "No verificado", value: "no_verificado" },
  ];

  // Opciones para filtro de período de fechas
  private fechaOptions = [
    { text: "Todo el tiempo", value: "todos" },
    { text: "Hoy", value: "hoy" },
    { text: "Última semana", value: "semana" },
    { text: "Último mes", value: "mes" },
  ];

  async mounted() {
    await this.loadHistory();
    await this.preloadEstados();
  }

  private safeItems(c: any): any[] {
    if (!c || !c.items || !(c.items instanceof Array)) return [];
    return c.items;
  }

  private safeTitle(prod: any): string {
    if (!prod) return "Producto";
    var t = (prod as any).titulo_producto;
    if (t && String(t).length > 0) return String(t);
    var n = (prod as any).name;
    if (n && String(n).length > 0) return String(n);
    return "Producto";
  }

  private safeImage(prod: any): string {
    if (!prod) return "";
    var l = (prod as any).large;
    return l ? String(l) : "";
  }

  private safePrecio(prod: any): number {
    if (!prod) return 0;
    var p: any = (prod as any).precio_venta;
    return Number(p || 0);
  }

  private lineTotal(it: any): number {
    var qty = Number(it && it.qty ? it.qty : 1);
    return this.safePrecio(it ? (it.producto_amazon || it.product) : null) * qty;
  }

  private getTotalQty(cart: any): number {
    return this.safeItems(cart).reduce((sum, item) => sum + (item.qty || 1), 0);
  }

  // --- MÉTODOS DE BORRADO ---
  private askDeleteCart(cartEntry: any) {
    this.itemToDelete = cartEntry;
    this.cartToDeleteType = 'cart';
    this.confirmDialog = true;
  }

  private askDeleteCartItem(item: any, cartId: number) {
    this.itemToDelete = { ...item, cartId };
    this.cartToDeleteType = 'item';
    this.confirmDialog = true;
  }

  private async executeDelete() {
    if (!this.itemToDelete) return;
    this.isDeleting = true;
    try {
      if (this.cartToDeleteType === 'cart') {
        const id = this.itemToDelete.cart.id;
        await CartModule.deleteCart(id);
        this.showSnack("Carrito eliminado exitosamente", "success");
      } else if (this.cartToDeleteType === 'item') {
        const id = this.itemToDelete.id;
        if (!id) throw new Error("Item ID not found");
        await CartModule.deleteCartItem(id);
        this.showSnack("Artículo eliminado exitosamente", "success");
      }
      this.confirmDialog = false;
      this.itemToDelete = null;
      this.cartToDeleteType = null;
      await this.refresh();
    } catch (e) {
      console.error(e);
      this.showSnack("Error al intentar eliminar", "error");
    } finally {
      this.isDeleting = false;
    }
  }

  private async loadHistory() {
    try {
      await CartModule.getAllCarts();
      this.history = CartModule.carts_loaded.map(function (h: any) {
        return h && typeof h.toPlain === "function" ? h.toPlain() : h;
      });
    } catch (e) {
      console.warn("loadHistory failed", e);
      this.history = [];
    }
  }

  // Indica si hay algún filtro activo (para mostrar el botón limpiar y el contador)
  get hayFiltrosActivos(): boolean {
    return (
      !!this.searchQuery ||
      !!this.searchCliente ||
      this.filtroEstado !== "todos" ||
      this.filtroVerificado !== "todos" ||
      this.filtroFecha !== "todos"
    );
  }

  get filteredHistory(): any[] {
    let filtered = [...this.history];

    // Filtro por producto o UID del carrito
    if (this.searchQuery) {
      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter((cart) => {
        const items = this.safeItems(cart.cart);
        return (
          items.some((item) =>
            this.safeTitle(item.product).toLowerCase().includes(query)
          ) ||
          (cart.cart.public_uid && String(cart.cart.public_uid).toLowerCase().includes(query))
        );
      });
    }

    // Filtro por cliente (nombre, email o teléfono)
    if (this.searchCliente) {
      const q = this.searchCliente.toLowerCase();
      filtered = filtered.filter((cart) => {
        const c = cart.client || {};
        return (
          (c.name  && String(c.name ).toLowerCase().includes(q)) ||
          (c.email && String(c.email).toLowerCase().includes(q)) ||
          (c.phone && String(c.phone).toLowerCase().includes(q))
        );
      });
    }

    // Filtro por estado del carrito
    if (this.filtroEstado !== "todos") {
      filtered = filtered.filter((cart) => {
        const estado = cart.cart.state;
        if (this.filtroEstado === "finalized") return estado === "finalized";
        if (this.filtroEstado === "en_curso")  return estado !== "finalized";
        return true;
      });
    }

    // Filtro por verificado
    if (this.filtroVerificado !== "todos") {
      filtered = filtered.filter((cart) => {
        const estaVerificado = this.itemsVerificados.includes(cart.cart.id);
        if (this.filtroVerificado === "verificado")    return estaVerificado;
        if (this.filtroVerificado === "no_verificado") return !estaVerificado;
        return true;
      });
    }

    // Filtro por rango de fechas
    if (this.filtroFecha !== "todos") {
      const ahora = new Date();
      filtered = filtered.filter((cart) => {
        const fecha = new Date(cart.cart.datecreated);
        if (isNaN(fecha.getTime())) return false;
        const diffMs = ahora.getTime() - fecha.getTime();
        const diffDias = diffMs / (1000 * 60 * 60 * 24);
        if (this.filtroFecha === "hoy")   return diffDias < 1;
        if (this.filtroFecha === "semana") return diffDias < 7;
        if (this.filtroFecha === "mes")   return diffDias < 30;
        return true;
      });
    }

    // Ordenación
    switch (this.sortBy) {
      case "oldest":
        filtered.sort(
          (a, b) =>
            new Date(a.cart.datecreated).getTime() -
            new Date(b.cart.datecreated).getTime()
        );
        break;
      case "price-high":
        filtered.sort(
          (a, b) => this.cartSubtotal(b.cart) - this.cartSubtotal(a.cart)
        );
        break;
      case "price-low":
        filtered.sort(
          (a, b) => this.cartSubtotal(a.cart) - this.cartSubtotal(b.cart)
        );
        break;
      case "items-most":
        filtered.sort(
          (a, b) =>
            this.safeItems(b.cart).length - this.safeItems(a.cart).length
        );
        break;
      case "items-least":
        filtered.sort(
          (a, b) =>
            this.safeItems(a.cart).length - this.safeItems(b.cart).length
        );
        break;
      default: // reciente
        filtered.sort(
          (a, b) =>
            new Date(b.cart.datecreated).getTime() -
            new Date(a.cart.datecreated).getTime()
        );
    }

    return filtered;
  }

  // Resetea todos los filtros a sus valores por defecto
  private limpiarFiltros() {
    this.searchQuery = "";
    this.searchCliente = "";
    this.filtroEstado = "todos";
    this.filtroVerificado = "todos";
    this.filtroFecha = "todos";
  }

  private refresh() {
    this.loadHistory().then(() => {
      this.showSnack("Actualizado", "success");
      this.preloadEstados();
    });
  }

  private cartSubtotal(c: any): number {
    var items = this.safeItems(c);
    var sum = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      sum += this.lineTotal(it);
    }
    return sum;
  }

  private formatPrice(v: any): string {
    var n = Number(v || 0);
    return n.toFixed(2);
  }

  private formatDate(val: any): string {
    if (!val) return "-";
    var d = new Date(val);
    if (isNaN(d.getTime())) return String(val);

    const now = new Date();
    const diff = now.getTime() - d.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (days === 0) return "Hoy";
    if (days === 1) return "Ayer";
    if (days < 7) return `Hace ${days} días`;
    if (days < 30) return `Hace ${Math.floor(days / 7)} semanas`;

    return d.toLocaleDateString("es-ES", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }

  private viewDetails(cart: any) {
    if (this.expandedCart === cart.id) {
      this.expandedCart = null;
    } else {
      this.expandedCart = cart.id;
    }
  }

  private showSnack(text: string, color: string = "success") {
    this.snackbarText = text;
    this.snackbarColor = color;
    this.snackbar = true;
  }
  private verificado_item_sync(cart: any) {
    for (const it of this.safeItems(cart)) {
      // Cuando se selecciona un carrito verificado se incrementa en un 5% el precio de cada producto
      if (it && it.product) {
        const precio_venta = Number(it.product.precio_venta || 0);
        it.product.precio_venta = precio_venta * 1.05;
        // ✅ Evita clics posteriores
        if (!this.itemsVerificados.includes(cart.id)) {
          this.itemsVerificados.push(cart.id);
        }
      }
    }
  }

  private estadosProductos: Record<string, string> = {};

  private mapEstadoToText(estado: number | null | undefined): string {
    if (estado == null) return "Desconocido";
    switch (estado) {
      case ProcessoNums.Disponible:
        return "Disponible";
      case ProcessoNums.Reservado:
        return "Reservado";
      case ProcessoNums.VendidoEfectivo:
      case ProcessoNums.VendidoTarjeta:
        return "Vendido";
      case ProcessoNums.Devolucion:
        return "Devolución";
      case ProcessoNums.MermaRoto:
        return "Merma/Roto";
      case ProcessoNums.Envio:
        return "Envío";
      case ProcessoNums.PendientePago:
        return "Pendiente de pago";
      case ProcessoNums.Reparacion:
        return "En reparación";
      default:
        return "Desconocido";
    }
  }

  /** Carga en bloque los estados de todos los productos presentes en this.history */
  private async preloadEstados(): Promise<void> {
    const ids = new Set<string>();
    for (const h of this.history) {
      for (const it of this.safeItems(h.cart)) {
        const id = it.product.id;
        if (id) ids.add(String(id));
      }
    }

    // Evita peticiones repetidas: sólo pide los que no tenemos
    const pendientes = [...ids].filter((id) => !(id in this.estadosProductos));

    if (pendientes.length === 0) return;

    try {
      const pendientesNum = pendientes.map(function(id) { return Number(id); });
      const estadosDic = await TiendaOnlineClientesModule.getEstadosProductos(pendientesNum);
      if (estadosDic) {
        for (const idStr of Object.keys(estadosDic)) {
          const estado = estadosDic[Number(idStr)];
          this.$set(this.estadosProductos, idStr, this.mapEstadoToText(estado));
        }
      }
    } catch (e) {
      console.warn("preloadEstados batch error", e);
    }
  }

  private view_estado_item_sync(item: ProductoAmazon): string {
    const id = item.id;
    if (!id) return "Desconocido";
    return this.estadosProductos[id] || "Cargando…";
  }

  private generarPresupuesto(entry: any) {
    (this as any).$router.push({
      name: RouterNames.ventas_cabecera_formulario,
      params: { id: "nuevo" },
      query: { id_carrito: String(entry.cart.id) },
    });
  }

  private abrirPublicarWordpress(entry: any) {
    this.carritoSeleccionado = entry;
    this.dialogWordpress = true;
  }

  /** Mapea los items del carrito seleccionado al formato ItemWpPopup esperado por PublicarWpPopup */
  get itemsDelCarritoSeleccionado() {
    if (!this.carritoSeleccionado || !this.carritoSeleccionado.items) return [];
    return this.carritoSeleccionado.items.map((item: any) => {
      let titulo       = "Producto";
      let precioAmazon = item.unit_price || 0;
      let imagen       = "";

      if (item.producto_amazon) {
        titulo       = item.producto_amazon.titulo_producto || titulo;
        precioAmazon = item.producto_amazon.precio_amazon  || precioAmazon;
        // Prioridad: hiRes -> large -> medium_image -> image_url -> thumb
        imagen = item.producto_amazon.hiRes || item.producto_amazon.large
               || item.producto_amazon.medium_image || item.producto_amazon.image_url || "";
      } else if (item.product_snapshot) {
        try {
          const snap   = typeof item.product_snapshot === "string"
            ? JSON.parse(item.product_snapshot) : item.product_snapshot;
          titulo       = snap.titulo_producto || titulo;
          precioAmazon = snap.precio_amazon   || precioAmazon;
          imagen       = snap.hiRes || snap.large || snap.medium_image || snap.image_url || "";
        } catch (e) { /* ignorar */ }
      } else if (item.product) {
        titulo       = item.product.titulo_producto || item.product.name || titulo;
        precioAmazon = item.product.precio_amazon   || item.product.precio_venta || precioAmazon;
        imagen       = item.product.hiRes || item.product.large || "";
      }

      return {
        titulo,
        qty:           item.qty || 1,
        precio_amazon: precioAmazon,
        // Precio de venta al 80% (consistente con el formulario de ventas)
        precio_venta:  Math.round(precioAmazon * 0.80 * 100) / 100,
        imagen,
      };
    });
  }
}
